import { render, staticRenderFns } from "./couponRecord.vue?vue&type=template&id=c1f1269a&scoped=true"
import script from "./couponRecord.vue?vue&type=script&lang=js"
export * from "./couponRecord.vue?vue&type=script&lang=js"
import style0 from "./couponRecord.vue?vue&type=style&index=0&id=c1f1269a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f1269a",
  null
  
)

export default component.exports